import React from 'react'
import Grid from '@material-ui/core/Grid';

import SystemDeviceFaultsPieCharts from './SystemDeviceFaultsPieCharts';
import SystemDeviceFaultsSelect from './SystemDeviceFaultsSelect';
import SystemDeviceFaultsHistogram from './SystemDeviceFaultsHistogram';
import SystemDeviceFaultsLog from './SystemDeviceFaultsLog'

const SystemDeviceFaults = () => {
  return (
    <Grid container spacing={16}>
        <Grid item md={12} sm={12} xs={12}>
            <SystemDeviceFaultsSelect/>
        </Grid>
        <Grid item md={6} sm={12} xs={12} >
            <SystemDeviceFaultsHistogram />
        </Grid>
        <Grid item md={6} sm={12} xs={12} >
            <SystemDeviceFaultsPieCharts />
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
            <SystemDeviceFaultsLog />
        </Grid>

    </Grid>
    
  )
}

export default SystemDeviceFaults